import React from "react";
import Menu from "./Menu";
import Hero from "./Hero";
import { useLocation } from "react-router-dom";
import { MenuProvider } from "./MenuContext";
import { useNode } from "../node";
import Logo from "./Logo";

export function Header() {
  const { pathname } = useLocation();
  const { node } = useNode();

  const background = node.featuredImage?.node?.src;
  const HeaderProps = { id: "header", className: "bg-secondary" };

  if (background) {
    HeaderProps.style = {
      backgroundImage: `url("${background}")`,
    };

    HeaderProps.className += " cover bg-center";
  }

  return (
    <header {...HeaderProps}>
      <MenuProvider>
        <Menu>
          <Logo h1={pathname === "/"} />
        </Menu>
      </MenuProvider>

      {pathname === "/" && <Hero />}
    </header>
  );
}

export default Header;
